
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/provider/[...provider]",
      function () {
        return require("private-next-pages/casino/provider/[...provider].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/provider/[...provider]"])
      });
    }
  